"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function cleanString(text) {
  var safeStr = !!text && typeof text === 'string' ? text : '';
  var withoutAccents = safeStr.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  return withoutAccents.toLowerCase();
}
exports.default = cleanString;